/**
 * Error Capture HTTP Interceptor
 *
 * Story 15.12: AI-Powered Feedback Collection System
 *
 * Логирует все HTTP запросы в ErrorCaptureService для контекста ошибок.
 * Перехватывает HTTP ошибки (5xx, network errors) для автоматического
 * создания инцидентов.
 */
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { ErrorCaptureService } from '../services/error-capture.service';

export const errorCaptureInterceptor: HttpInterceptorFn = (req, next) => {
  const errorCapture = inject(ErrorCaptureService);
  const startTime = Date.now();

  return next(req).pipe(
    tap({
      next: () => {
        // Успешный запрос — логируем для контекста
        errorCapture.logNetworkRequest({
          url: req.url,
          method: req.method,
          status: 200,
          duration: Date.now() - startTime,
        });
      },
      error: (error: unknown) => {
        if (error instanceof HttpErrorResponse) {
          // Логируем ошибочный запрос
          errorCapture.logNetworkRequest({
            url: req.url,
            method: req.method,
            status: error.status,
            duration: Date.now() - startTime,
            error: error.message,
          });

          // Уведомляем ErrorCaptureService о HTTP ошибке
          errorCapture.handleHttpError(error);
        }
      },
    })
  );
};
